import { render, staticRenderFns } from "./OnBoardingFourthStep.vue?vue&type=template&id=03cb2ad6&"
import script from "./OnBoardingFourthStep.vue?vue&type=script&lang=js&"
export * from "./OnBoardingFourthStep.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingFourthStep.vue?vue&type=style&index=0&id=03cb2ad6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports